export default "__VITE_ASSET__8ada3f94__"